import Cookies from "js-cookie";

import { auth } from "js/firebase/auth";
import { openWindowAndWaitForItToBeClosed } from "js/core/utilities/selfClosingWindow";

export class BoxAuthError extends Error { }
export class BoxAuthFlowWasInterruptedError extends BoxAuthError { }

interface BoxAuthTokens {
    accessToken: string
}

/**
 * Grants our app offline access for the given scope, executes the redirect ouath flow in a separate window
 * and saves the tokens
 */
export async function grantOfflineAccess(): Promise<BoxAuthTokens> {
    const userIdToken = await auth().currentUser.getIdToken();
    Cookies.set("user_id_token", userIdToken, { sameSite: "strict", expires: new Date(Date.now() + 60 * 1000) });

    const url = `${window.location.origin}/box/auth` +
        `?continueUrl=${encodeURIComponent("/close")}` +
        "&requestOfflineAccess=true";

    const lastSearchParams = await openWindowAndWaitForItToBeClosed(url);

    const error = lastSearchParams.get("box_auth_error");
    if (error) {
        throw new BoxAuthError(error);
    }

    const accessToken = Cookies.get("box_access_token");
    Cookies.remove("box_access_token");

    if (!accessToken && !error) {
        throw new BoxAuthFlowWasInterruptedError();
    }

    return { accessToken };
}
